import { FilterableList } from "../filterable-list";
import _ = require("lodash");
import { FilterParameter } from "../models/types"
import {SuccessStoriesMap} from "../widgets/sucess-stories-map";
import {Helpers} from "../helpers/helpers";

export class SuccessStoryList extends FilterableList<SuccessStory>
{
	private stateFilterDropdown: HTMLSelectElement;	
	filterWrapper: HTMLElement;
	private storyMap: SuccessStoriesMap;
	private countryFilterDropDown: HTMLSelectElement;
	private searchPreforming: NodeJS.Timeout;
	
	public constructor() {
		super(".success-stories-list .cards");		
		this.storyMap = new SuccessStoriesMap();

		if (Helpers.isNullOrUndefined(this.resultsWrapper)) return;
		
		const parameters = Helpers.getUrlParameters();
		if (!Object.prototype.hasOwnProperty.call(parameters, "filters")) {
			this.onQueryChange([]);
		}

		this.countryFilterDropDown = document.querySelector(".success-stories-section .country-filter") as HTMLSelectElement;
		this.stateFilterDropdown = document.querySelector(".success-stories-section .state-filter") as HTMLSelectElement;
		this.initStateCountyDropDown();
		this.initMapIconKey();

		
	}

	private initStateCountyDropDown() {
		this.countryFilterDropDown.addEventListener('change', () => {
			const country = this.countryFilterDropDown.value;			
			if (country !== "USA" && country !== "Canada" && country !== "UnitedKingdom") {				
				this.preformSearch();
			}
		});
		this.stateFilterDropdown.addEventListener('change', () => {		
			this.preformSearch();
		});
	}

	preformSearch(filters: FilterParameter[] = null) {
		clearTimeout(this.searchPreforming);
		this.searchPreforming = setTimeout(()=>{
			if (!filters) {
				filters = this.getSelectedFilters();
			}
			if (this.countryFilterDropDown?.value || this.stateFilterDropdown?.value) {
				let countyStateFilter: FilterParameter = {
					countryCode: this.countryFilterDropDown?.value,
					codeName: "",
					categoryIds: [],
					categoryParent: "",
					stateCode: this.stateFilterDropdown?.value
				};
				filters.push(countyStateFilter);
			}

			this.search(this._searchUrl, filters, false, (results)=> {				
				//this.updateUrlWithFilters(filters);
			});

			this.search(this._searchUrlAll, filters, false, (results)=> {				
				this.storyMap.updateLocationPoints(results?.results);
			});
		}, 800)
		
	
		
	
	}
	
	createResult(dataItem: SuccessStory): void {
		const template = document.querySelector('.success-story-template .col-md-4').cloneNode(true) as HTMLElement;
		const image = template.querySelector('.image') as HTMLElement;
		const title = template.querySelector('h3');
		const classification = template.querySelector('.classification');
		const url = template.querySelector('a') as HTMLAnchorElement;
		const content = template.querySelector('.content .summary');
		if (dataItem.image) {
			const cleanUrl = dataItem.image.replace("~", "");
			image.style.backgroundImage = `url('${cleanUrl}')`;
			image.querySelector('.no-image').remove();
		}

		title.innerHTML = dataItem.title;
		content.innerHTML = dataItem.summary;
		if (dataItem.shouldLinkToDocument) {
			url.href = dataItem.storyDocument.replace("~", "");
		} else {
			url.href = dataItem.detailUrl.replace("~", "");
		}

		classification.innerHTML = dataItem.location;
		this.resultsWrapper.append(template);
	}


	clearResults(): void {		
		if (this.resultsWrapper) {			
			this.resultsWrapper.innerHTML = "";
		}
	}

	private readonly _searchUrl = "/success-stories/search";
	private readonly _searchUrlAll = "/success-stories/all";

	onQueryChange(selectedFilters: FilterParameter[]): void {
		this.clearResults();
		if (selectedFilters.length > 0) {
			document.querySelector('.section-expandable.expanded')?.classList.remove('expanded');
		}
		this.preformSearch(selectedFilters);
	}

	toggleLoader(isLoading: boolean): void {
		const loader = document.querySelector('.success-stories-list .loader');

		if (isLoading) {
			loader.classList.remove('d-none');
		} else {
			loader.classList.add('d-none');
			this.resultsWrapper.classList.remove('d-none');
			this.paginationContainer.classList.remove('d-none');
		}
	}


	private initMapIconKey() {
		const mapIconToggle = document.querySelector('.map-icon-toggle') as HTMLElement;
		const mapIconList = document.querySelector('.map-icons') as HTMLElement;
		
		mapIconToggle.addEventListener('click', (e) => {
			mapIconToggle.classList.toggle('open');
			mapIconList.classList.toggle('open');
		})
		
	}
}

export interface SuccessStory {
	title: string;
	location: string;
	storyDocument: string;
	summary: string;
	image: string;
	pageIcon: string;
	shouldLinkToDocument: boolean;
	detailUrl: string;
	longitude: number;
	latitude: number;
	mapIconName: string;
}